"use client";

import { useJobPageAuth } from "@/components/JobPageAuth";
import { SaveJobButton } from "@/components/SaveJobButton";
import { VideoApplicationCta } from "@/components/VideoApplicationCta";
import type { SaveJobInput } from "@/lib/saved-jobs";

/** SaveJobButton wired to the job page's client-reconciled auth state. */
export function AutoSaveJobButton({
  job,
  compact,
  block = false,
}: {
  job: SaveJobInput;
  compact?: boolean;
  block?: boolean;
}) {
  const { isAuthed, isSaved } = useJobPageAuth();
  return (
    <SaveJobButton
      job={job}
      initialSaved={isSaved}
      isAuthed={isAuthed}
      compact={compact}
      block={block}
    />
  );
}

/** VideoApplicationCta wired to the job page's client-reconciled auth state. */
export function AutoVideoApplicationCta({
  jobId,
  jobTitle,
  orgName,
  applyUrl,
}: {
  jobId: number;
  jobTitle: string;
  orgName: string;
  applyUrl: string;
}) {
  const { isAuthed, isPaid } = useJobPageAuth();
  return (
    <VideoApplicationCta
      jobId={jobId}
      jobTitle={jobTitle}
      orgName={orgName}
      applyUrl={applyUrl}
      isPaid={isPaid}
      isAuthed={isAuthed}
    />
  );
}
